import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'
import type { ShiftType } from '@/features/shiftTemplate/domain/enums/ShiftType'

export class ShiftEntity {
  id?: string
  shiftTemplateId?: string
  startDateTime?: string
  duration?: string
  size?: number
  type?: ShiftType
  shiftId?: string
  region?: RegionMiniEntity
}
